import React from 'react';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { SidebarTrigger, useSidebar } from '@/components/ui/sidebar';

import SEO from '@/components/SEO';

export default function APISpecs() {
  const { isMobile } = useSidebar();

  return (
    <div className="flex flex-col flex-1 overflow-y-auto p-4 md:p-6 lg:p-8 bg-background text-foreground">
      <SEO title="API Specs - Ankh Studio" description="API specifications for various services" />
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-bold">API Specs</h1>
          {!isMobile && (
            <Input placeholder="Search API specs..." className="w-1/3" />
          )}
          {isMobile && <SidebarTrigger />}
        </div>

        <Card>
          <CardHeader>
            <CardTitle>API Specs</CardTitle>
            <CardDescription>API specifications for various services</CardDescription>
          </CardHeader>
          <CardContent>
            <p>List of API specifications will be displayed here.</p>
          </CardContent>
        </Card>
    </div>
  );
}
